export enum LayoutType {
  ONE_COLUMN = 'layout_one_column',
  TWO_COLUMN = 'layout_two_columns'
}
